// Created by hejikun on 2017/11/2 0002.
let kunhuaPhysicalExamination = [
  // ===================================
  // 1. 机构主页与基础信息
  // ===================================
  {
    path: '/kunhua_physicalExamination_index',
    name: '体检预约',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_index')
  },
  {
    path: '/kunhua_physicalExamination_inde_detail',
    name: '体检预约',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_inde_detail')
  },
  {
    path: '/kunhua_physicalExamination_star_list',
    name: '体检预约',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_star_list')
  },

  // ===================================
  // 2. 套餐列表与详情
  // ===================================
  {
    path: '/kunhua_physicalExamination_oneList',
    name: '体检预约',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_oneList')
  },
  {
    path: '/kunhua_physicalExamination_oneList_kunhua',
    name: '体检预约',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_oneList_kunhua')
  },
  {
    path: '/kunhua_physicalExamination_detail',
    name: '体检预约',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_detail')
  },
  {
    path: '/kunhua_physicalExamination_recommend_more',
    name: '体检预约',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_recommend_more')
  },

  // ===================================
  // 3. 下单与加项流程
  // ===================================
  {
    path: '/kunhua_physicalExamination_order_confirm',
    name: '体检预约',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_order_confirm')
  },
  {
    path: '/kunhua_physicalExamination_addition',
    name: '体检预约',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_addition')
  },
  {
    path: '/kunhua_physicalExamination_pay_confirm',
    name: '体检预约',
    component: () => import('@/pages/kunhuaPhysicalExamination/pay_confirm')
  },

  // ===================================
  // 4. 支付流程
  // ===================================
  {
    path: '/kunhua_physicalExamination_orderPay',
    name: '体检预约',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_orderPay')
  },

  // ===================================
  // 5. 订单管理与售后
  // ===================================
  {
    path: '/kunhua_physicalExamination_orderList',
    name: '体检预约',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_orderList')
  },
  {
    path: '/kunhua_physicalExamination_new_detail',
    name: '体检预约',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_new_detail')
  },
  {
    path: '/kunhua_physicalExamination_orderDetail',
    name: '体检预约',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_orderDetail')
  },
  {
    path: '/kunhua_physicalExamination_change_time',
    name: '体检预约',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_change_time')
  },
  {
    path: '/kunhua_physicalExamination_evaluate',
    name: '体检预约',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_evaluate')
  },

  // ===================================
  // 6. 售后加项业务
  // ===================================
  {
    path: '/kunhua_physicalExamination_add_items',
    name: '体检预约',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_add_items')
  },
  {
    path: '/kunhua_physicalExamination_add_detail',
    name: '体检预约',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_add_detail')
  },
  {
    path: '/kunhua_physicalExamination_add_order_list',
    name: '体检预约',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_add_order_list')
  }
]
export default kunhuaPhysicalExamination
